import { mapValues } from 'lodash';

/**
 * Version 5 migrations for the event website.
 * - Add filter configuration to sessions widget
 */
export default function v5(website) {
  return {
    ...website,
    eventVersion: 5,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'Sessions' && !layoutItem.config.filter) {
        return { ...layoutItem,
          config: { ...layoutItem.config,
            filter: { displayKeywordFilter: false },
            style: { ...layoutItem.config.style,
              sessionFilter: {
                searchLabelStyles: { styleMapping: 'label' },
                searchInputStyles: { styleMapping: 'input' }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
